// extracted by mini-css-extract-plugin
export default {"container":"TitleBlock_container__RqEnr","bg":"TitleBlock_bg__KaOg7","button":"TitleBlock_button__tJqEP"};